import { useState, useEffect } from 'react';
import api from '../../services/api';
import { API } from '../../App';

/** Full Samsara fleet (all vehicles, not just ones mapped to a branch
 * registry) for the Historical Data Centre's vehicle pickers — each vehicle
 * carries its mapped branch_id (C30/E70) when one exists. */
export const useVehicleRegistry = () => {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`${API}/transport/samsara/all-vehicles`)
      .then((res) => setVehicles(res.data.vehicles || []))
      .catch(() => setVehicles([]))
      .finally(() => setLoading(false));
  }, []);

  return { vehicles, loading };
};

export default useVehicleRegistry;
